<template>
  <div>
    <main-feature id="feature" :features="features" :title="$t('header.feature')" />
    <div class="section-divider"></div>
    <more-feature :apps="apps" />
  </div>
</template>

<style scoped>
.section-divider {
  width: 80%;
  max-width: 900px;
  height: 1px;
  margin: 0 auto;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(63, 81, 181, 0.18) 20%,
    rgba(244, 67, 54, 0.15) 80%,
    transparent 100%
  );
}
</style>

<script>
import MainFeature from "./MainFeature";
import MoreFeature from "./MoreFeature";

export default {
  components: {
    MainFeature,
    MoreFeature
  },
  props: {
    apps: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    features() {
      return this.$t("features");
    }
  }
};
</script>
